export default __webpack_public_path__ + "static/media/logo.721cbc84.png";